import RouterLink from '@app/components/RouterLink';
import DevText from '@app/components/Text';
import { UserUtils } from '@app/containers/components/Notifications/utils';
import { Colors } from '@blueprintjs/core';
import React from 'react';
import NotificationTemplate from '../../../../NotificationTemplate';
import { NotificationResource, TaskResource } from 'dy-frontend-http-repository/lib/modules/Notification/resources';
import { Endpoints } from '@app/data/consts';

export interface TaskPriorityRemovedNotificationProps {
    authorizedUserId: ID;
    notification: NotificationResource;
    task: TaskResource | null;
}

type Props = TaskPriorityRemovedNotificationProps;

const TaskPriorityRemovedNotification: React.FC<Props> = ({ authorizedUserId, notification, task }) => {
    const renderContent = () => {
        if (!task) {
            // This is bad, task is NOT found, which should not happen
            return <DevText color={Colors.RED2}>Request was not found</DevText>;
        }

        return (
            <div>
                <DevText running className="mb-1">
                    {UserUtils.getActorUserName(notification.activity.actor_user, authorizedUserId)} removed priority
                    for{' '}
                    <RouterLink
                        style={{ display: 'inline' }}
                        to={Endpoints.TASK_INFORMATION.replace(':taskId', task.id)}
                    >
                        {task.title}
                    </RouterLink>
                </DevText>
            </div>
        );
    };

    return (
        <NotificationTemplate
            title="Priority removed"
            icon="chevron-down"
            at={notification.activity.at}
            content={renderContent()}
        />
    );
};

export default TaskPriorityRemovedNotification;
